import ActionsForm from '@/shared/mixins/actionsForm'
import ExpenseMixin from '@/views/private/finance/expenses/travelexpensezpag/mixins/ExpenseMixin'
import AutocompleteZ from '@/components/forms/AutocompleteZ.vue'
import AprAnalisePreliminarRisco from '@/shared/http/repositories/business/aprInquery'
import aprAtividade from '@/shared/http/repositories/business/aprAtividade'
import { toast, loading } from '@/shared/utils/UIHelper'

export default {
  name: 'aprReportFiltro',
  components: {AutocompleteZ},
  mixins: [ActionsForm, ExpenseMixin],
  data () {
    return {
      statusApr: [],
      form: {
        Apr: null,
        status: null,
        InicioDataSolicitacao: null,
        FimDataSolicitacao: null,
        AtividadeId: null
      },
      dataAtividade: []
    }
  },
  mounted () {
    this.GetStatusApr()
    this.GetAtividade()
  },
  methods: {
    Search () {
      this.$emit('search', {CodigoAPR: this.form.Apr, StatusApr: this.form.status, AtividadeId: this.form.AtividadeId, DataInicioAPR: this.form.InicioDataSolicitacao, DataFimAPR: this.form.FimDataSolicitacao})
    },
    onClearSection () {
      this.form.Apr = null
      this.form.InicioDataSolicitacao = null
      this.form.FimDataSolicitacao = null
      this.form.AtividadeId = null
      this.form.status = null
    },
    GetAtividade () {
      loading.push()
      aprAtividade.GetAtividades()
        .then((Response) => {
          loading.pop()
          this.dataAtividade = Response.data
        }).catch(Error => {
          loading.pop()
          toast.error('Erro ao carregar as informações')
        })
    },
    GetStatusApr () {
      loading.push()
      AprAnalisePreliminarRisco.GetAllStatusApr()
        .then((Response) => {
          loading.pop()
          this.statusApr = [...Response.data]
        })
        .catch((Error) => {
          console.error(Error)
        })
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/apr/aprReport/components/aprReportTable/components/aprReportFiltro/aprReportFiltro.js